import { useQuery } from "@tanstack/react-query";
import { ApiGetBalanceV2 } from "@/api";

export const useBalanceV2 = () => {
  const { data, isLoading, error } = useQuery({
    queryKey: ["balanceV2"],
    queryFn: async () => {
      const res = await ApiGetBalanceV2();
      console.log("useBalanceV2", res.data);
      return res.data;
    },
  });
  const getTokenBalanceData = (tokenAddress: string) => {
    if (!data) return null;
    return data?.items?.find(item => item.coinContract === tokenAddress);
  };
  return { data, isLoading, error, getTokenBalanceData };
};
